<template>
<div class="contenido">
        <div class="banG">
            &nbsp;
        </div>
        <div class="limitado">
           
            <div class="texto">
                 <h1>Zintegrowane wzmacniacze lampowe</h1>
                <p>Wzmacniacze zintegrowane Line Magnetic to kwintesencja filozofii producenta, która łączy klasyczne, lampowe brzmienie z solidną, ręczną konstrukcją i estetyką nawiązującą do złotego wieku audio. Są to urządzenia, które odziedziczyły pasję do lamp elektronowych i legendarnych osiągnięć amerykańskiej elektroniki z lat 50.</p>

                <p>Wzmacniacze Line Magnetic to propozycja dla melomanów poszukujących autentycznego, lampowego brzmienia, połączonego z niezawodną konstrukcją i klasycznym designem. To urządzenia, które oferują nie tylko wysoką jakość dźwięku, ale także pewnego rodzaju "doświadczenie" obcowania z tradycyjną i ręcznie wykonaną elektroniką.</p>

            </div>
           
        </div>
  <div class="limitado prod">
    <div class="equipo" v-for="product in products" :key="product.sku">
      <router-link :to="'/produkty/' + product.sku">
        <h3>{{ product.sku }}</h3>
        <img :src="'/images/' + product.picture[0].name" :alt="product.name" />
        <p v-html="product.shortDescription"></p>
      </router-link>
    </div>
  </div>
  
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useHead } from '@vueuse/head'


const products = ref([])

useHead({
  title: 'Wzmacniacze Line Magnetic - Produkty',
  meta: [
    { name: 'description', content: 'Poznaj pełną ofertę wzmacniaczy lampowych Line Magnetic w Polsce.' },
    { property: 'og:title', content: 'Produkty Line Magnetic' },
  ]
})
onMounted(async () => {
  const res = await fetch('/products.json')
  products.value = await res.json()
})
</script>
